export default __webpack_public_path__ + "static/media/book1.7f060b66.svg";